import CircularRectTextButton, {
    CircularRectTextButtonProps,
} from "@/components/CircularButton/styled/CircularRectTextButton";
import { themeColors } from "@/utils/themeColors";

type FollowButtonProps = { isFollowing: boolean } & Omit<CircularRectTextButtonProps, "children">;

/**
 * CircularRectTextButton wrapper for follow button animation
 */
const FollowButton = ({ sx, isFollowing, ...buttonProps }: FollowButtonProps) => {
    return (
        <CircularRectTextButton
            className="bodyBold1"
            sx={{
                width: "14.2rem",
                color: themeColors.primaryDark,
                backgroundColor: isFollowing ? "transparent" : themeColors.primary,
                outline: isFollowing ? `1px solid ${themeColors.neutral1}` : "none",
                padding: "1.2rem 6rem",
                height: "5rem",
                ...sx,
            }}
            {...buttonProps}>
            {isFollowing ? "Unfollow" : "Follow"}
        </CircularRectTextButton>
    );
};

export default FollowButton;
